var _circle, _circle2, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoModalZong(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 36,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4209 39.252H14.6235V36.2897H26.6177V36.9111L19.1968 47.8279H26.3892V50.7903H14V50.1689L21.4209 39.252Z",
    fill: "#8DC63F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5488 42.546V50.7906H43.3477V36.1865H43.9712L53.7828 44.4726V36.29H56.9839V50.8941H56.3604L46.5488 42.546Z",
    fill: "#8DC63F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0547 43.6647C58.0547 38.6929 61.5678 36 66.0995 36C67.8247 36 69.7372 36.3937 71.4625 37.3673L70.7558 40.3297C69.3422 39.5216 67.7832 39.0452 66.141 39.0452C63.2934 39.0452 61.4224 40.6816 61.4224 43.644C61.4224 46.3783 63.0022 48.0354 65.9333 48.0354C67.9705 48.0354 69.883 47.0618 70.2569 45.446H66.0164V42.898H73.0007V50.8939H72.4603L70.4231 48.9466C69.4668 50.2101 67.6378 51.0802 65.6421 51.0802C61.0066 51.0802 58.0547 48.1386 58.0547 43.6643V43.6647Z",
    fill: "#8DC63F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.339 36.0162C29.745 36.0162 26.3984 39.1442 26.3984 43.5563C26.3984 47.9685 29.3635 50.728 33.5424 51.064V47.9726C31.3051 47.6452 29.7661 45.9346 29.7661 43.5563C29.7661 40.9256 31.6787 39.0818 34.3394 39.0818C37.0001 39.0818 38.9126 40.9256 38.9126 43.5563C38.9126 45.9346 37.3733 47.6452 35.1364 47.9726V51.0637C39.2983 50.7262 42.2803 47.747 42.2803 43.5563C42.2803 39.1439 38.913 36.0162 34.3397 36.0162H34.339Z",
    fill: "#8DC63F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoModalZong);
export default __webpack_public_path__ + "static/media/logoModalZong.2d81fdcf0021ffebdd5af86dc534b489.svg";
export { ForwardRef as ReactComponent };